import React from "react";
import style from "./Adminwelcom.module.css"
import logo from "../assets/logo.png"
import dec1 from "../assets/dec1.png"
import dec2 from "../assets/dec2.png"
import { useNavigate } from "react-router";
const Adminwelcom=()=>{
    const navigate = useNavigate();
    const todashboard=()=>{
        navigate("/dashboard")
    }
    return(
        <div className={style.container}>
            <div className={style.rcircle}></div>
            <div className={style.nav}>
                <a href="https://archminaashraf.com/">
                    <img src={logo}/>
                </a>
                <div className={style.content}>
                    <h2>مرحبا بعودتك مهندس مينا </h2>
                    <p>من فضلك اضغط <span>اسفل</span> للدخول  الي صفحة التحكم </p>
                </div>
                <img src={dec1} alt="icon"/>
            </div>
            <button onClick={todashboard}>اضغط هنا </button>
            <img src={dec2} className={style.dec2} alt="." />
            <div className={style.lcircle}></div>
        </div>
    )
}
export default Adminwelcom;